<template>
  <BContent
    v-loading="loading"
    invisible-navbar
    class="home"
  >
    <LeadViewList />
    <SisenseContextProvider
      :url="sisenseUrl"
      sso-enabled
    >
      <template v-if="sisenseAuthChecked">
        <NextActionCharts />
      </template>
    </SisenseContextProvider>
  </BContent>
</template>

<script setup lang="ts">
import {
  SisenseContextProvider,
} from '@sisense/sdk-ui-vue';
import { computed } from 'vue';
import LeadViewList from '@/components/organisms/user/cockpit/LeadViewList.vue';
import NextActionCharts from '@/components/organisms/user/cockpit/NextActionCharts.vue';
import { useSisense } from '@/composable/user/sisense/sisense';
import { useWait } from '@/composable/vue-wait';

const { sisenseAuthChecked } = useSisense();
const { wait } = useWait();
const sisenseUrl = `${import.meta.env.VITE_SISENSE_URL}`;

const loading = computed(() => {
  return wait.is('checkSisenseAccount');
});
</script>

<style lang="scss" scoped>
.home {
  background-color: #F5F7FA;
}
:deep(.b-height-adjuster > .content) {
  height: 100%;
  padding: $basespace-300 $basespace-600;
}
</style>
